import {defineCssVars} from '@chakra-ui/styled-system';

export const vars = defineCssVars(`filters-menu-list`, [`width`, `height`, `item-width`]);
